import React from 'react'

import { useTheme } from '@mui/material'
import { useFormContext, useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FormInputFieldEntity } from '../../types'
import { CommonTextField } from '../CommonTextField'

export const FormTextField: React.FC<FormInputFieldEntity> = ({
  type,
  name,
  label,
  placeholder,
  variant = 'standard',
  ...rest
}) => {
  const { t } = useTranslation()
  const { palette, spacing } = useTheme()
  const { control } = useFormContext()
  const {
    field,
    fieldState: { error },
  } = useController({ name, control })

  return (
    <CommonTextField
      type={!!type ? type : 'text'}
      label={label}
      id={name}
      placeholder={placeholder}
      error={!!error}
      helperText={!!error && error.message ? t(String(error.message)) : ''}
      variant={variant}
      InputLabelProps={{
        sx: {
          fontSize: spacing(2),
          fontWeight: 500,
          color: palette.grey[700],
          '&.MuiInputLabel-root': {
            ...(variant === 'standard' && { top: spacing(-2) }),
          },
        },
      }}
      InputProps={{
        margin: 'none',
        sx: {
          fontSize: '16px',
          fontWeight: 500,
        },
      }}
      {...field}
      {...rest}
    />
  )
}
